import QuizGradingLayout from 'components/QuizGrading/QuizGradingLayout';

const Tablet = (props) => <QuizGradingLayout device={'tablet'} {...props} />;
export default Tablet;
